/** Hash helpers - used for duplicate-generation prevention (spec section 54). */

/**
 * FNV-1a 32-bit hex digest. Not cryptographic: it exists only so the
 * studio can recognise "I have already generated this exact prompt".
 */
export function hashString(input) {
  let h = 2166136261 >>> 0;
  const str = String(input);
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

/**
 * Stable signature for a generation request. Two requests with the same
 * signature would produce the same asset, so the UI can warn first.
 */
export function generationSignature({ providerId, sceneId, prompt, durationSeconds, aspectRatio, resolution, model }) {
  return hashString(
    [providerId, sceneId, model ?? '', String(prompt ?? '').trim(), durationSeconds, aspectRatio, resolution].join('|'),
  );
}

/**
 * Cheap similarity check: token Jaccard over normalised words.
 * Returns 0..1. Used to warn about *nearly* identical prompts.
 */
export function similarity(a, b) {
  const tok = (s) =>
    new Set(
      String(s ?? '')
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .split(/\s+/)
        .filter((w) => w.length > 2),
    );
  const A = tok(a);
  const B = tok(b);
  if (!A.size && !B.size) return 1;
  if (!A.size || !B.size) return 0;
  let inter = 0;
  for (const w of A) if (B.has(w)) inter += 1;
  return inter / (A.size + B.size - inter);
}
